import React, { ReactNode } from 'react';
import { NavLink } from 'react-router-dom';
import styled from 'styled-components';

import Tooltip from '../../../../components/Tooltip';
import brandingLightPng from '../../../../kingpin/atoms/Icon/assets/Branding/large-light.png';
import useDarkModeToggle from '../../../../theme/useDarkModeToggle';
import BrandIcon from '../../../../images/brand-dark.svg';

export const V3_TOP_BAR_HEIGHT = 58;

const TopBarDiv = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: ${V3_TOP_BAR_HEIGHT}px;
  padding: 0 24px 0 16px;
  background-color: var(--color-bg-primary);
  border-bottom: 1px solid var(--color-border-secondary);
`;

const LeftSection = styled.div`
  display: flex;
  align-items: center;
  gap: 20px;
`;

const LogoContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 6px 8px 8px 9px;

  cursor: pointer;
  &:hover {
    background-color: var(--color-bg-tertiary);
    border-radius: 6px;
  }
`;

const Logo = styled.img`
  display: flex;
  width: 90px;
`;

const NavContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 4px;
`;

const RightSection = styled.div`
  display: flex;
  align-items: center;
  gap: 16px;
`;

const NavContainerRight = styled.div`
  display: flex;
  align-items: center;
  gap: 4px;
`;

const HomeLogo = () => {
  const { isDarkMode } = useDarkModeToggle();

  return (
    <NavLink to={'/'}>
      <LogoContainer>
        <Tooltip content={'Go To Home'}>
          <Logo src={isDarkMode ? brandingLightPng : BrandIcon} />
        </Tooltip>
      </LogoContainer>
    </NavLink>
  );
};

const TopBarLayout = ({
  Left,
  Right,
}: {
  Left: ReactNode;
  Right: ReactNode;
}) => {
  return (
    <TopBarDiv>
      <LeftSection>
        <HomeLogo />
        <NavContainer>{Left}</NavContainer>
      </LeftSection>
      <RightSection>
        <NavContainerRight>{Right}</NavContainerRight>
      </RightSection>
    </TopBarDiv>
  );
};

export default TopBarLayout;
